<template>
  <div>
    <base-header>
      <div class="row align-items-center pt-header">
        <div
          class="col-lg-4 col-md-6 col-sm-6 col-12 d-flex align-items-center"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-12 alinmov3"></div>
      </div>
    </base-header>
    <div class="container-fluid mt-0">
      <div class="row justify-content-center">
        <!-- <div
          class="
            col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12
            order-lg-1 order-md-2 order-sm-2 order-2
          "
        >
          <div class="card">
            <div class="row">
              <div class="col-8">
                <h2 class="subtitle">Notifications</h2>
              </div>
              <div class="col-4 text-right">
                <i class="flaticon-settings"></i>
              </div>
            </div>

            <collapse :multipleActive="false">
              <collapse-item name="Push Notifications">
                <h4 slot="title" class="subtitle mb-0">Push Notifications</h4>

                <div slot="subtitle" class="text-notif">
                  <span>Show received notification for new updates</span>
                </div>

                <div class="row border-bottom pb-2 pt-2">
                  <div
                    class="
                        col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8
                        align-self-center
                      "
                  >
                    <div>
                      <span>New Reservation</span>
                    </div>
                  </div>

                  <div
                    class="
                        col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4
                        align-self-center
                      "
                  >
                    <base-switch v-model="notification.show.new"></base-switch>
                  </div>
                </div>
              </collapse-item>

              <collapse-item name="Sound Notifications">
                <span slot="title" class="subtitle mb-0"
                  >Sound Notifications</span
                >
                <div slot="subtitle" class="text-notif">
                  <span>Turn on/off sound for notifications</span>
                </div>

                <div class="row border-bottom pb-2 pt-2">
                  <div
                    class="
                        col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8
                        align-self-center
                      "
                  >
                    <div>
                      <span>New Reservation</span>
                    </div>
                  </div>

                  <div
                    class="
                        col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4
                        align-self-center
                      "
                  >
                    <base-switch v-model="notification.sound.new"></base-switch>
                  </div>
                </div>
              </collapse-item>
            </collapse>
          </div>
        </div> -->
        <div
          class="
            col-xl-6 col-lg-8 col-md-12 col-sm-12 col-12
            order-lg-2 order-md-1 order-sm-1 order-1
          "
        >
          <div class="card">
            <div class="row">
              <div class="col-sm-4 col-12 align-self-center">
                <h2 class="subtitle">Notifications</h2>
              </div>
              <div class="col-sm-8 col-12 alinmov2 align-self-center">
                <WSelect
                  placeholder="Filters"
                  v-model="filter"
                  id="filter"
                  label="filter"
                  class="w-30 d-inline-block mr-2"
                >
                  <el-option
                    v-for="option in filters"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  ></el-option>
                </WSelect>

                <span class="link"> Mark all as read</span>
              </div>
            </div>

            <!-- si no hay notificaciones mostrar esto -->

            <!-- <base-alert type="secondary" class="alert-box">
              <h4><strong>Waiting Notifications!</strong></h4>

              There are no notifications

              <img
                src="~rhomtrip_assets/src/img/character/notification.png"
                alt="Rhomtrip waiting"
                class="character"
              />
            </base-alert> -->

            <div class="list-group list-group-flush mb-5">
              <basenotifications
                v-for="(item, index) in notifications"
                :key="index"
                :to="item.to"
                :type="item.type"
                :user="item.responsible"
                :title="item.title"
                :message="item.message"
                :datetime="item.timestamps"
                :read="item.viewed"
              ></basenotifications>
            </div>

            <div class="footer-list" v-if="notifications.pages > 1">
              <base-pagination
                class="justify-content-center"
                :pageCount="notifications.pages"
                v-model="currentPage"
                @changePage="changePage"
                @nextPage="nextPaginations"
                @prevPage="preventPaginations"
              ></base-pagination>
            </div>
          </div>
        </div>
      </div>

      <div
        class="
            col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12
            order-lg-3 order-md-2 order-sm-2 order-2
          "
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import notifications from "../components/BaseNotifications.vue";
import WSelect from "@/components/Select";
import Swal from "sweetalert2";
import { goBack } from "../../../helpers/commons.helpers";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "notifications",
  data() {
    return {
      filter: "all",
      filters: [
        { label: "All", value: "all" },
        { label: "Read", value: "read" },
        { label: "Unread", value: "unread" }
      ],
      settingsNotifications: {
        show: {
          all: true,
          new: true,
          updated: true,
          cancelled: true,
          completed: true,
          assigned: true,
          unassigned: true,
          accepted: true,
          started: true,
          onlocation: true,
          pob: true,
          noshow: true
        },
        sound: {
          all: false,
          new: true,
          updated: true,
          cancelled: true,
          completed: true,
          assigned: true,
          unassigned: true,
          accepted: true,
          started: true,
          onlocation: true,
          pob: true,
          noshow: true
        }
      },
      notifications: [
        {
          to: "/",
          title: "New Guide: How to create a Document",
          type: "updated",
          message:
            "It is the document that details the release of a specific version, which may contain changes or improvements compared to previous versions.",
          timestamps: "2 hrs ago",
          viewed: false,
          responsible: "Helen White"
        },
        {
          to: "/",
          title: "New release: Version 2.8.0",
          type: "created",
          message:
            "We're excited to announce the integration of a new payment method for Partners",
          timestamps: "2 hrs ago",
          viewed: true,
          responsible: "Helen White"
        }
      ]
    };
  },
  components: {
    basenotifications: notifications,
    WSelect: WSelect,
    Swal
  },
  created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Notifications",
        active: true
      }
    ];
    this.setItemsBread(bread);
  },
  methods: {
    goToPreviousPage() {
      goBack(this);
    },
    ...mapMutations(["setLoad", "setItemsBread", "setSesion"])
  }
};
</script>
